module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website_tablet-de6ad671d0664b02988a463245919d1a.png";